import { useState } from 'react';
import { useRouter } from 'next/router';
import { Button } from 'components/Button';
import { CurrentUser, CustomerProfile } from 'types';
import { tabs, TabType } from './tabsMap';

import cx from 'classnames';
import styles from './UserProfile.module.scss';

export type HeaderBarProps = {
  user?: CurrentUser;
  profile: CustomerProfile;
  activeTab: TabType;
  onChangeTab: (tab: TabType) => void;
  onFollow: () => void | boolean;
  onSendReport?: () => void;
  onBlock?: (block: boolean) => void;
};

export const UserProfileHeaderBar = ({ user, profile, activeTab, onChangeTab, onFollow, onSendReport, onBlock }: HeaderBarProps) => {
  const [isFollowed, setIsFollowed] = useState<boolean>(profile.is_followed);
  const [isFollowingProcess, setIsFollowingProcess] = useState<boolean>(false);

  const router = useRouter();

  const toSettings = () => {
    return router.push('/account-settings');
  };

  const toMessage = () => {
    return router.push(`/messages/rooms/users/${profile.id}`);
  };

  const handleFollow = async () => {
    if (isFollowingProcess) {
      return;
    }
    setIsFollowingProcess(true);
    const successFollowing = await onFollow();
    if (successFollowing) {
      setIsFollowed(!isFollowed);
    }
    setIsFollowingProcess(false);
  }

  const handleClickSendReport = () => {
    onSendReport && onSendReport();
  };

  const handleClickBlock = () => {
    onBlock && onBlock(!profile.is_blacklisted);
  };

  return (
    <div className={styles.headerBar}>
      <div className={styles.headerBarTabs}>
        {tabs.map(tab => (
          <p key={tab.id} className={cx(styles.headerBarTabItem, {
            [styles.headerBarTabItemActive]: activeTab === tab.id,
          })} onClick={() => onChangeTab(tab.id)}>
            {tab.label} {tab.counter && (<span className={styles.headerTabItemCounter}>{tab.counter(profile)}</span>)}
          </p>
        ))}
      </div>
      {!!user && (
        <div className={styles.headerBarActions}>
          {user.id === profile.id ? (
            <div className={styles.headerBarActionWrapper}>
              <Button caption="Edit Profile" action={toSettings} buttonHeight="low" buttonType="white" />
            </div>
          ) : (
            <>
              <div className={styles.headerBarActionWrapper}>
                <Button caption="Message" action={toMessage} buttonHeight="low" buttonType="white" />
              </div>
              <div className={styles.headerBarActionWrapper}>
                <Button
                  caption={isFollowed ? 'Unfollow' : 'Follow'}
                  action={handleFollow}
                  buttonHeight="low"
                  disabled={isFollowingProcess}
                />
              </div>
              {!profile.is_deleted && (
                <div className={styles.headerBarActionIconWrapper}>
                  <Button
                    caption=""
                    iconSrc="/icons/security/Flag.svg"
                    action={handleClickSendReport}
                    buttonHeight="low"
                    buttonType="white"
                    fit={false}
                    iconOnly
                  />
                </div>
              )}
              {!profile.is_deleted && (
                <div className={styles.headerBarActionIconWrapper}>
                  <Button
                    caption=""
                    iconSrc={profile.is_blacklisted ? "/icons/security/UnblockUser.svg" : "/icons/security/BlockUser.svg"}
                    action={handleClickBlock}
                    buttonHeight="low"
                    buttonType="white"
                    fit={false}
                    iconOnly
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
